<template>
  <v-list ref="menu" class="py-0 pl-0 overflow-auto" :class="{'isMobile': isMobile}">
    <div v-for="(link, i) in dataLinks" :key="i">
      <v-list-item
        :to="link.route"
        class="leftmenu-link-item"
        :class="{'pl-1': isMobile}"
        active-class="activeLink"
        :href="link.url"
        :target="link.url ? '_blank' : ''"
        @click="switchLinks(link)"
      >
        <div>
          <v-icon class="activeLink-icon uikit-icon" :class="link.icon" />
        </div>

        <v-list-item-content class="ma-0 ml-3 pa-0">
          <v-list-item-title class="leftmenu-link-text">
            {{ link.text }}
          </v-list-item-title>
        </v-list-item-content>

        <div v-if="link.links" class="d-flex align-center justify-center">
          <v-icon class="activeLink-icon uikit-icon chevron-down" />
        </div>
      </v-list-item>

      <v-list
        v-if="!mini && link.linksSwitcher"
        id="subleftmenu-list"
        class=" ml-5 py-0"
        :class="{'isMobile': isMobile}"
      >
        <div v-for="(item, i) in link.links" :key="i">
          <v-list-item
            :to="item.route"
            class="pr-2 pl-2 subleftmenu-link-item"
            :class="{'pl-1': isMobile}"
            active-class="subActiveLink"
          >
            <v-list-item-icon class="mr-1 my-3 ml-2">
              <v-icon class="subicon uikit-icon" :class="item.icon" />
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title class="leftmenu-link-text">
                {{ item.text }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </div>
      </v-list>
    </div>
  </v-list>
</template>

<script>
export default {
  name: 'MenuLinks',

  props: {
    links: {
      type: Array,
      default: null,
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
    mini: {
      type: Boolean,
      default: false,
    },
  },

  mounted() {
    this.dataLinks = [...this.links]
    // eslint-disable-next-line no-param-reassign,no-return-assign
    this.$route.matched.length && this.dataLinks.map((el) => (el.route === this.$route.matched[0].path ? el.linksSwitcher = true : el.linksSwitcher = false))

    this.setMenuHeight()
    window.addEventListener('resize', this.setMenuHeight)
  },

  destroyed() {
    window.removeEventListener('resize', this.setMenuHeight)
  },

  data: () => ({ dataLinks: [] }),

  methods: {
    switchLinks(item) {
      if (item.linksSwitcher !== null) {
        // eslint-disable-next-line no-param-reassign,no-return-assign
        this.dataLinks.map((el) => (el.id === item.id ? el.linksSwitcher = true : el.linksSwitcher = false))
      }
    },

    setMenuHeight() {
      this.$nextTick(() => {
        if (this.$refs?.menu) {
          const footerHeight = 67 - 8
          const topHeight = this.$refs.menu.$el.getBoundingClientRect().top

          this.$refs.menu.$el.style.maxHeight = `${window.innerHeight - topHeight - footerHeight}px`
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.activeLink {
  color: var(--v-primary-base) !important;
  background-color: var(--v-lightBlue-base);
  border-radius: 8px;

  .activeLink-icon {
    background: var(--v-primary-base) !important;
  }
}

.activeLink.leftmenu-link-item {
  color: var(--v-primary-base) !important;
}

.subActiveLink {
  color: var(--v-primary-base) !important;
  background-color: transparent;

  .subicon {
    background: var(--v-primary-base) !important;
  }
}

.isMobile .v-list-item {
  background-color: var(--v-background-base);
}

.leftmenu-link-text {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 135%;
}

.theme--light.v-list-item--active:before, .theme--light.v-list-item--active:hover:before {
  border-radius: 8px !important;
  background: transparent !important;
}

.theme--light.v-list-item:hover:before {
  border-radius: 8px !important;
  opacity: 0;
}

.theme--light.v-list-item:hover:active {
  border-radius: 8px !important;
}

.v-list-item {
  margin: 0 !important;
}

.leftmenu-link-item {
  padding-right: 16px !important;
  padding-left: 16px !important;
  color: var(--v-primaryBlack-base) !important;
}

.leftmenu-link-item:hover {
  border-radius: 8px !important;
  background: var(--v-lightBlue-base) !important;
}

#subleftmenu-list .subleftmenu-link-item:hover {
  color: var(--v-primary-base) !important;
  background: transparent !important;

  .subicon {
    background: var(--v-primary-base) !important;
  }
}
</style>
